import { Roles, SettingsSubCategories } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import AzureADSuccess from '../../components/AzureADSuccess/AzureADSuccess';

export const AzureADSuccessRouting = (props: LogicalRouteImportProps) => {
    const disabled = !useHasPermissions({ permission: SettingsSubCategories.AUTHORIZE, role: Roles.EDITOR });

    return <LogicalRoute {...props} component={AzureADSuccess} disabled={disabled} />;
};
